export const STATIC_REPORTS_CONFIG = [
  {
    id: 'leaderboard',
    name: 'Leaderboard',
    description: 'Monthly FSR ranking by contracts created',
    frequency: 'Monthly',
    icon: 'pi-trophy',
    allowedRoles: ['SUPER_DEV_ADMIN', 'SA', 'A',]
  },
  {
    id: 'product',
    name: 'Product Report',
    description: '12-month rolling product performance with trends',
    frequency: 'Monthly',
    icon: 'pi-box',
    allowedRoles: ['SUPER_DEV_ADMIN', 'SA', 'A',]
  },
  {
    id: 'team-activity',
    name: 'Team Activity',
    description: 'Weekly interactions breakdown per team member',
    frequency: 'Weekly',
    icon: 'pi-users',
    allowedRoles: ['SUPER_DEV_ADMIN', 'SA', 'A',]
  },
  {
    id: 'pipeline-alert',
    name: 'Pipeline Alert',
    description: 'Active reservations expiring in next 7 days',
    frequency: 'Daily',
    icon: 'pi-bell',
    allowedRoles: ['SUPER_DEV_ADMIN', 'SA', 'A', ]
  },
  {
    id: 'fsr-performance',
    name: 'FSR Team Performance',
    description: 'Quarterly aggregated KPIs and performance metrics',
    frequency: 'Quarterly',
    icon: 'pi-chart-line',
    allowedRoles: ['SUPER_DEV_ADMIN', 'SA', 'A', ]
  },
  {
    id: 'personal-pipeline',
    name: 'Personal Pipeline',
    description: 'Your active and expired reservations',
    frequency: 'Daily',
    icon: 'pi-calendar',
    allowedRoles: ['SUPER_DEV_ADMIN','FSR']
  },
  {
    id: 'monthly-winloss',
    name: 'Monthly Win/Loss',
    description: 'Your monthly wins and lost deals',
    frequency: 'Monthly',
    icon: 'pi-check-circle',
    allowedRoles: ['SUPER_DEV_ADMIN','FSR']
  },
  {
    id: 'personal-performance',
    name: 'Personal Performance',
    description: 'Your quarterly KPIs and performance review',
    frequency: 'Quarterly',
    icon: 'pi-user',
    allowedRoles: ['SUPER_DEV_ADMIN','FSR']
  }
];

